import { render, staticRenderFns } from "./DmsRolesTabs.vue?vue&type=template&id=5352467d"
import script from "./DmsRolesTabs.vue?vue&type=script&lang=js"
export * from "./DmsRolesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports